import {useEffect} from 'react';

interface OldAccountFilterItem {
    value: number;
    label: string;
}

/**
 * Хук для миграции старых данных фильтра счетов из формата {value, label} в массив ID
 * @param oldKey - Ключ в localStorage для старых данных (например, 'logs_filter_accounts')
 * @param newKey - Ключ в localStorage для новых данных (например, 'logs_filter_account_ids')
 * @param currentIds - Текущий массив ID (из useLocalStorage)
 * @param setIds - Функция для установки новых ID (из useLocalStorage)
 */
const useAccountFilterMigration = (
    oldKey: string,
    newKey: string,
    currentIds: number[] | undefined | null,
    setIds: ((ids: number[]) => void) | undefined
): void => {
    useEffect(() => {
        const oldData = localStorage.getItem(oldKey);
        const newData = localStorage.getItem(newKey);
        
        // Проверяем, есть ли старые данные и нет ли новых
        if (oldData && (!newData || JSON.parse(newData)?.length === 0)) {
            try {
                const parsed: OldAccountFilterItem[] = JSON.parse(oldData);
                if (parsed.length > 0 && parsed[0]?.value) {
                    // Это старый формат с объектами {value, label}
                    const ids = parsed.map(item => item.value);
                    
                    // Если используется setIds (хук), вызываем его, иначе сохраняем напрямую
                    if (typeof setIds === 'function') {
                        setIds(ids);
                    } else {
                        localStorage.setItem(newKey, JSON.stringify(ids));
                    }
                    
                    // Удаляем старый ключ
                    localStorage.removeItem(oldKey);
                }
            } catch (e) {
                // Игнорируем ошибки парсинга
                console.warn('Error migrating old filter account data:', e);
            }
        }
    }, []); // Выполняем только один раз при монтировании
};

export default useAccountFilterMigration;
